/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { SERVICE_TYPES } from 'shared';

import { PlanStorageCreateRequest } from '../../../../types/su-plan/requests/PlanStorageCreateRequest';

export type CreatePlanStorageDialogValues = PlanStorageCreateRequest;

export const formInitialValues: CreatePlanStorageDialogValues = {
  name: '',
  serviceType: 'postgres',
  storageClassId: '',
  size: 0,
  isVisible: false,
};

export const validationSchema = Yup.object({
  name: Yup.string().required('empty'),
  size: Yup.number().positive('not_positive').required('empty'),
  serviceType: Yup.string()
    .oneOf([...SERVICE_TYPES])
    .required('empty'),
  storageClassId: Yup.string().required('empty'),
  isVisible: Yup.boolean(),
});
